import MUIToggleButton from '@mui/material/ToggleButton';
import PropTypes from 'prop-types';
import React, {forwardRef} from 'react';
import Tooltip from '@mui/material/Tooltip';
import {styled} from '@mui/material/styles';

const ToggleButton = forwardRef(
  ({title, placement = 'right', disabled, ...props}, ref) => (
    <Tooltip title={title} placement={placement}>
      <MUIToggleButton
        component={disabled ? 'div' : undefined}
        role="button"
        disabled={disabled}
        ref={ref}
        size="small"
        {...props}
      />
    </Tooltip>
  )
);

ToggleButton.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  disabled: PropTypes.bool,
};

export default styled(ToggleButton)(({theme}) => ({
  '&.MuiToggleButton-root': {
    color: theme.palette.common.white,
    border: 'none',
    margin: theme.spacing(1, 0),
    borderRadius: theme.shape.borderRadius,
  },
  '&.Mui-selected': {
    color: theme.palette.teal[300],
    backgroundColor: theme.palette.grey[800],
    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    display: 'inline-flex',
  },
  '&.Mui-disabled:hover': {
    backgroundColor: 'transparent',
  },
}));
